
































































































































/** @format */

import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { Getter } from 'vuex-class';
// import ParkingLotSearch from '@/components/parking-lot-search/index.vue'
import { cloneDeep } from 'lodash';
import { trim } from '@/utils/validators';
import Utils from '@/utils/common';
// axios请求
import { addOrEditStord } from '@/api/exception-management';

// form表单项定义
export interface IForm {
  parentId: string;
  cnName: any;
  username: string;
  sequence: any;
  status: string;
  describes: any;
}

@Component({
  components: { ParkingLotSearch: () => import('@/components/parking-lot-search/index.vue') }
})
export default class AddEditData extends Vue {
  @Prop({ default: () => {} })
  dataForm!: any;

  @Prop()
  parkId!: string;

  @Prop()
  total!: any;

  @Prop()
  parentId!: any;

  @Prop({ type: Boolean, default: false })
  isEdit!: boolean;

  @Prop({ type: Boolean, default: false })
  addEditvisible!: boolean;

  provinceData: any = [
    { label: '手动抬杆原因', value: 'cp_order_hand_lift_record_lift_cause' },
    { label: '特殊放行原因', value: 'cp_order_special_record_release_cause' }
  ];
  // 表单
  form: any = null;
  validatorsTrim = trim;

  @Watch('dataForm', { deep: true })
  dataChanged(val: any) {
    this.init();
  }

  @Watch('total', { deep: true })
  totalChanged(val: any) {
    if (!this.isEdit) {
      this.init();
      this.$nextTick(() => {
        this.form.setFieldsValue({ sequence: val + 1 });
      });
    }
  }

  @Watch('parentId', { deep: true })
  parentIdChanged(val: any) {
    if (!this.isEdit) {
      this.form.setFieldsValue({ parentId: val });
    }
  }

  // 关闭弹框
  handleCancel() {
    // this.form.resetFields()
    this.resetForm();
    this.$emit('hanleClose');
  }
  // 清除表单内容
  resetForm() {
    this.form.setFieldsValue({ cnName: '', describes: '' });
  }
  // 生命周期初始化
  created() {
    this.init();
    if (!this.isEdit) {
      this.form.setFieldsValue({ sequence: this.total + 1 });
    }
  }

  // 初始化form表单
  init() {
    if (this.isEdit && this.dataForm) {
      this.form = this.$form.createForm(this, {
        mapPropsToFields: () => {
          const { parentId, username, sequence, status, describes, cnName } = this.dataForm;
          return {
            parentId: this.$form.createFormField({
              value: parentId
            }),
            username: this.$form.createFormField({
              value: username
            }),
            sequence: this.$form.createFormField({
              value: sequence
            }),
            status: this.$form.createFormField({
              value: status
            }),
            cnName: this.$form.createFormField({
              value: cnName
            }),
            describes: this.$form.createFormField({
              value: describes
            })
          };
        }
      });
    } else {
      this.form = this.$form.createForm(this, {
        mapPropsToFields: () => {
          return {
            sequence: this.$form.createFormField({
              value: this.total + 1
            }),
            parentId: this.$form.createFormField({
              value: this.parentId
            })
          };
        }
      });
    }
  }

  // 提交监听处理
  async handleSubmit(e: any) {
    // e.stopPropagation()
    e.preventDefault();
    this.form.validateFields(async (err: boolean, values: IForm) => {
      if (!err) {
        console.log(values, '拿到了');
        this.onAddOrEdit({ ...values });
      }
    });
  }
  // 提交请求发送添加

  // 添加和编辑
  async onAddOrEdit(values: IForm) {
    // TIP: 和后端沟通接口返回ID给前端
    if (this.isEdit && this.dataForm.sequence === values.sequence) {
      delete values.sequence;
    }
    if (this.isEdit && this.dataForm.cnName === values.cnName) {
      delete values.cnName;
    }
    if (this.isEdit && this.dataForm.describes === values.describes) {
      delete values.describes;
    }
    try {
      const res = await addOrEditStord({
        ...values,
        ...(this.isEdit ? { id: this.dataForm.id } : {})
      });
      this.$message.success(`${this.isEdit ? '编辑' : '新增'}成功`);
      // 提交成功保存返回ID，再添加列表的编辑功能中有用
      this.$emit('ok', {
        ...values
      });
      // this.form.resetFields()
      this.resetForm();
    } catch (e) {
      this.$message.error((e && e.msg) || `${this.isEdit ? '编辑' : '新增'}失败`);
      console.log(e);
    }
  }
  /**
   * form布局
   */
  formItemLayout = {
    labelCol: {
      xs: { span: 24 },
      sm: { span: 6 }
    },
    wrapperCol: {
      xs: { span: 24 },
      sm: { span: 14 }
    }
  };
  tailFormItemLayout = {
    wrapperCol: {
      xs: {
        span: 20,
        offset: 4
      },
      sm: {
        span: 18,
        offset: 6
      }
    }
  };
  centerFormItemLayout = {
    wrapperCol: {
      xs: {
        span: 20,
        offset: 4
      },
      sm: {
        span: 14,
        offset: 10
      }
    }
  };
}
